import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_simple/test-components")({
    component: TestComponents,
});

function TestComponents() {
    return <div>TestComponents</div>;
}
